import React, {} from 'react';

function ListaCampos({ datosCampos, nombreCampoSeleccionado, handleCambioCampo }) {
    //datosCampos: Arreglo de DatosCampo (esriAuxClasses.js)

    function handleChange(e){
        handleCambioCampo(e.target.value);
    }

    return (
        <select className='esri-select' value={nombreCampoSeleccionado} onChange={handleChange}>
            {
                datosCampos.map(campo =>
                    <option key={campo.name} value={campo.name}>{campo.alias}</option>
                )
            }
        </select>
    );
}

export default ListaCampos;